<template>
  <VanDialog v-model:show="store.showInputModal">
    <template #title>
      <div class="text-center text-base font-bold">
        {{ t("ConfirmModal.enterContent") }}
      </div>
    </template>
    <div class="flex flex-col gap-4 py-4 px-6">
      <VanField
        v-model="store.modalInputContent"
        rows="1"
        :autosize="{ minHeight: 24, maxHeight: 400 }"
        type="textarea"
        class="mt-2.5 text-[#ABABAB]"
      />
    </div>

    <template #footer>
      <div class="flex justify-center py-4">
        <button class="btn btn-primary btn-sm mr-2" @click="clickInsert">
          {{ t("Buttons.confirm") }}
        </button>

        <button class="btn btn-sm" @click="store.showInputModal = false">
          {{ t(`story.g.cancel`) }}
        </button>
      </div>
    </template>
  </VanDialog>
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";
import { useI18n } from "vue-i18n";

const store = useGalGameEditor();
const { t } = useI18n();
const clickInsert = async () => {
  const { activeNode, modalInputType, activeDialog, activeDialogOption } =
    store;
  store.showInputModal = false;
  if (modalInputType === "dialogText") {
    activeDialog.text = store.modalInputContent;
    store.saveDialog();
  } else if (modalInputType === "dialogOption") {
    activeDialogOption.text = store.modalInputContent;
    store.saveDialogOption();
  } else {
    if (modalInputType === "name") {
      activeNode.name = store.modalInputContent;
    } else if (modalInputType === "description") {
      activeNode.description = store.modalInputContent;
      if (activeNode.type === 3 && activeNode.dialogzzCount === 0)
        store.addDialog(4, activeNode.description);
    }
    store.saveNode();
  }
};
</script>
